export const getDataLayer = () => window.dataLayer || [];

export const fireGtmEvent = (eventName, gtmEventData = {}) => {
    gtmEventData.event = eventName;
    getDataLayer().push(gtmEventData);
};
